(() => {
  'use strict';
  const config = document.getElementById('NzcAttributionConfig');
  if (!config || config.dataset.mode !== 'production-observe') return;
  const endpoint = config.dataset.endpoint;
  if (!endpoint || !endpoint.startsWith('/apps/club-quotes/attribution-live/')) return;
  const KEY = 'nzc-attribution-production-v1', REVOKE = 'nzc-attribution-production-withdrawal-v1';
  const DAY = 86400000;
  let session, ready, generation = 0, pageCaptured = false;
  const controllers = new Set();
  const anchors = new Map();
  const preparations = new WeakMap();
  const navigating = new WeakSet();
  let permittedPage;
  const diagnose = code => document.dispatchEvent(new CustomEvent('nzc:attribution-status', {detail:{code,at:new Date().toISOString()}}));
  const withdrawals = new Map();
  let flushing;
  const consent = () => {
    try {
      const p = window.Shopify?.customerPrivacy;
      return { marketing: p?.marketingAllowed() === true, analytics: p?.analyticsProcessingAllowed() === true, saleOfData: p?.saleOfDataAllowed() === true };
    } catch { return { marketing: false, analytics: false, saleOfData: false }; }
  };
  const allowed = () => { const c = consent(); return c.marketing && c.analytics && c.saleOfData; };
  const random = () => Array.from(crypto.getRandomValues(new Uint8Array(24)), b => b.toString(16).padStart(2, '0')).join('');
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch { return null; } };
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return localStorage.getItem(key) === JSON.stringify(value); } catch { return false; }
  };
  const remove = key => { try { localStorage.removeItem(key); } catch {} };
  const cleanPage = raw => {
    try {
      const u = new URL(raw, location.origin);
      if (!['www.nzcricketstore.com', 'nzcricketstore.com'].includes(u.hostname) || u.username || u.password) return null;
      if (!/^\/$|^\/(products|collections|pages|blogs)\/[a-z0-9/-]{1,180}\/?$/.test(u.pathname)) return 'https://www.nzcricketstore.com/';
      const v = u.searchParams.get('variant');
      return 'https://www.nzcricketstore.com' + u.pathname + (/^\d{1,25}$/.test(v || '') ? '?variant=' + v : '');
    } catch { return null; }
  };
  const evidence = () => {
    const u = new URL(location.href), campaign = {}, clicks = {};
    for (const k of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term']) {
      const v = u.searchParams.get(k);
      if (/^[a-zA-Z0-9][a-zA-Z0-9_. -]{0,99}$/.test(v || '') && (['utm_campaign','utm_id'].includes(k)||!/\b\d{7,}\b/.test(v))) campaign[k] = v;
    }
    for (const k of ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid']) {
      const v = u.searchParams.get(k); if (/^[a-zA-Z0-9_-]{10,256}$/.test(v || '')) clicks[k] = v;
    }
    let referrer = null;
    try { const r = new URL(document.referrer); if (r.protocol === 'https:' && !r.username && !r.password) referrer = r.origin; } catch {}
    return { at: new Date().toISOString(), landing: cleanPage(location.href), referrer, campaign, clicks };
  };
  async function request(action, body, revoke = false) {
    if (!revoke && !allowed()) throw new Error('consent');
    const controller = new AbortController(); controllers.add(controller);
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(endpoint + action, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin', signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('unavailable');
      return await response.json();
    } finally { clearTimeout(timeout); controllers.delete(controller); }
  }
  async function flushWithdrawal() {
    if (flushing) return flushing;
    const stored = read(REVOKE);
    for (const item of Array.isArray(stored) ? stored : stored ? [stored] : []) {
      if (item?.visitId && item?.token) withdrawals.set(item.visitId, item);
    }
    flushing = (async () => {
      for (const [id, item] of withdrawals) {
        try { await request('revoke', item, true); withdrawals.delete(id); } catch {}
      }
      if (withdrawals.size) write(REVOKE, [...withdrawals.values()]); else remove(REVOKE);
    })();
    try { await flushing; } finally { flushing = null; }
  }
  function withdraw() {
    generation++;
    controllers.forEach(c => c.abort());
    anchors.forEach((href, anchor) => { anchor.href = href; }); anchors.clear();
    document.querySelectorAll('[data-nzc-attribution-reference]').forEach(x=>x.remove());
    const old = session || read(KEY);
    if (old?.visitId && old?.token) {
      withdrawals.set(old.visitId, { visitId: old.visitId, token: old.token });
      const stored = read(REVOKE);
      for (const item of Array.isArray(stored) ? stored : stored ? [stored] : []) if (item?.visitId && item?.token) withdrawals.set(item.visitId, item);
      write(REVOKE, [...withdrawals.values()]);
    }
    remove(KEY); session = null; ready = null; pageCaptured = false; permittedPage = null;
    void flushWithdrawal();
  }
  async function start() {
    if (!allowed()) { if (session || read(KEY)) withdraw(); return; }
    // Capture immediately at the first permitted opportunity, before any network await.
    permittedPage ||= evidence();
    if (withdrawals.size || read(REVOKE)) {
      await flushWithdrawal();
      if (withdrawals.size || read(REVOKE) || !allowed()) return;
    }
    if (ready) return ready;
    session = read(KEY);
    if (!session || !/^[a-f0-9]{48}$/.test(session.visitId || '') || !/^[a-f0-9]{48}$/.test(session.token || '') || session.expiresAt <= Date.now()) {
      session = { visitId: random(), token: random(), expiresAt: Date.now() + 90 * DAY, pending: [] };
      if (!write(KEY, session)) { session = null; return; }
    }
    if (!Array.isArray(session.pending)) session.pending = [];
    if (!pageCaptured) {
      const item = permittedPage;
      {
        if (session.pending.length >= 20) return;
        session.pending.push(item);
        if (!write(KEY, session)) return;
      }
      pageCaptured = true;
    }
    const current = generation;
    ready = (async () => {
      while (session?.pending.length) {
        await request('arrival', { visitId: session.visitId, token: session.token, evidence: session.pending[0], consent: consent() });
        if (current !== generation || !allowed()) throw new Error('withdrawn');
        session.pending.shift(); session.firstRecorded = true;
        if (!write(KEY, session)) throw new Error('storage');
      }
      return session;
    })().catch(() => { ready = null; return null; });
    return ready;
  }
  function prepare(anchor, context = {}) {
      if (!allowed()) return Promise.resolve(null);
      const previous = preparations.get(anchor);
      const signature=JSON.stringify(context);
      if(previous && previous.generation===generation && previous.signature===signature && (anchor.href===previous.original||anchor.href===previous.decorated))return previous.promise;
      const original = anchor.href;
      const marker = String(Date.now()) + random(); anchor.dataset.nzcAttributionGeneration = marker;
      anchors.set(anchor, original);
      const current = generation;
      const state={signature,original,decorated:null,generation};
      state.promise=(async()=>{try {
        const s = await start();
        if (!s || !allowed()) return;
        const result = await request('enquiry', { visitId: s.visitId, token: s.token, requestId: random(), context: { url: cleanPage(context.url||location.href), variant: context.variant || null, channel:context.channel||'whatsapp',entryPoint:context.entryPoint||'direct-link' }, consent: consent() });
        if (current !== generation || !allowed() || anchor.dataset.nzcAttributionGeneration !== marker || !/^NZC-[A-F0-9]{20}$/.test(result.reference || '')) return;
        const u = new URL(original);
        if (u.origin === 'https://wa.me' && u.pathname === '/64204779045')u.searchParams.set('text', (u.searchParams.get('text') || '') + '\nRef: ' + result.reference);
        else if(u.protocol==='mailto:'&&u.pathname.toLowerCase()==='info@nzcricketstore.com')u.searchParams.set('body',(u.searchParams.get('body')||'')+'\nRef: '+result.reference);
        else return;
        anchor.href = u.href;
        state.decorated=u.href;diagnose('REFERENCE_READY');return result.reference;
      } catch {diagnose('REFERENCE_UNAVAILABLE');return null;}})();
      preparations.set(anchor,state);
      state.promise.then(reference=>{if(!reference&&preparations.get(anchor)===state)preparations.delete(anchor);});
      return state.promise;
  }
  window.NzcAttribution = Object.freeze({prepare});
  document.addEventListener('click',event=>{
    const anchor=event.target.closest?.('a[href]');
    if(!anchor||event.defaultPrevented||event.button>0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||!allowed())return;
    let url;try{url=new URL(anchor.href);}catch{return;}
    const whatsapp=url.origin==='https://wa.me'&&url.pathname==='/64204779045';
    const email=url.protocol==='mailto:'&&url.pathname.toLowerCase()==='info@nzcricketstore.com'&&anchor.closest('#NzcContactDialog');
    if(!whatsapp&&!email)return;
    const state=preparations.get(anchor);if(state?.generation===generation&&state?.decorated===anchor.href)return;
    event.preventDefault();if(navigating.has(anchor))return;navigating.add(anchor);
    const promise=(state?.generation===generation&&state?.promise)||prepare(anchor,{url:location.href,channel:email?'email':'whatsapp',entryPoint:'direct-link'});
    let timer;
    Promise.race([promise,new Promise(resolve=>{timer=setTimeout(()=>{diagnose('HANDOFF_TIMEOUT');resolve(null);},1200);})]).finally(()=>{
      clearTimeout(timer);navigating.delete(anchor);location.assign(anchor.href);
    });
  },true);
  // Native Shopify contact submissions remain native; a reference is only intent,
  // never receipt proof. The received mailbox copy must confirm it independently.
  document.querySelectorAll('form input[name="form_type"][value="contact"]').forEach(input=>{
    const form=input.form;if(!form)return;
    let referencePromise, referenceGeneration=-1, resubmitting=false, handoffPending=false;
    const prepareForm=()=>{
      if(!allowed())return Promise.resolve(null);
      if(referencePromise&&referenceGeneration===generation)return referencePromise;
      referenceGeneration=generation;
      const link=document.createElement('a');link.href='mailto:info@nzcricketstore.com';
      referencePromise=prepare(link,{url:location.href,channel:'contact_form',entryPoint:'contact-form'}).then(reference=>{
        if(!reference||!allowed()){referencePromise=null;return null;}const hidden=document.createElement('input');hidden.type='hidden';hidden.name='contact[NZC enquiry reference]';hidden.value=reference;hidden.dataset.nzcAttributionReference='true';form.append(hidden);return reference;
      });
      return referencePromise;
    };
    form.addEventListener('focusin',prepareForm);
    form.addEventListener('submit',event=>{
      if(resubmitting||event.defaultPrevented||!allowed()||form.querySelector('[data-nzc-attribution-reference]'))return;
      event.preventDefault();if(handoffPending)return;handoffPending=true;const submitter=event.submitter;let timer;
      Promise.race([prepareForm(),new Promise(resolve=>{timer=setTimeout(resolve,1200);})]).finally(()=>{
        clearTimeout(timer);handoffPending=false;resubmitting=true;
        try{form.requestSubmit(submitter||undefined);}finally{resubmitting=false;}
      });
    });
  });
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) {withdraw();document.querySelectorAll('[data-nzc-attribution-reference]').forEach(x=>x.remove());} else void start(); });
  window.addEventListener('storage', event => { if (event.key === KEY && !event.newValue) withdraw(); });
  window.addEventListener('online', () => { void flushWithdrawal(); if (allowed()) void start(); });
  window.addEventListener('pageshow', () => { if (!allowed()) withdraw(); });
  void flushWithdrawal();
  if (window.Shopify?.customerPrivacy) void start();
  else if (window.Shopify?.loadFeatures) {
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) void start(); }); } catch {}
  }
})();
